import { z } from "zod"

export const animalSchema = z.object ( {
	gn: z.string ().min ( 3, "GN is Required" ).max ( 4 ),
	// birthDate: z.string({message: 'birth date is Required'}),
	sex: z.string ().min ( 1, { message: "select area type" } ),
	breedingType: z
			.string ()
			.min ( 1, { message: "Breeding Type is Required" } )
			.default ( "unknown" ),
	name: z.string ( { message: "Name is Required" } ),
	weight: z.string ().min ( 1, "Weight is Required" ),
	vaccination: z.string ().min ( 1, { message: "select area type" } ),
	damDGR: z.string ().default ( "unknown" ),
	damName: z
			.string ( { message: "Mother's Name is Required" } )
			.default ( "unknown" ),
	damBreed: z
			.string ()
			.min ( 1, { message: "Mother's Breed is Required" } )
			.default ( "unknown" ),
	sireDGR: z.string ().default ( "unknown" ),
	sireName: z
			.string ()
			.min ( 1, { message: "Father's Name is Required" } )
			.default ( "unknown" ),
	sireBreed: z
			.string ()
			.min ( 1, { message: "Father's Breed is Required" } )
			.default ( "unknown" ),
	paternalGrandDamDGR: z
			.string ( { message: "Sire Mother's Name is Required" } )
			.default ( "unknown" ),
	paternalGrandDamName: z
			.string ()
			.min ( 1, {
				message: "Sire Mother's DGR is" + " Required",
			} )
			.default ( "unknown" ),
	paternalGrandDamBreed: z
			.string ()
			.min ( 1, { message: "Sire Mother's Breed is" + " Required" } )
			.default ( "unknown" ),
	paternalGrandSireDGR: z
			.string ()
			.min ( 1, { message: "Sire Father's DGR is" + " Required" } )
			.default ( "unknown" ),
	paternalGrandSireName: z
			.string ()
			.min ( 1, { message: "Sire Father's Name is" + " Required" } )
			.default ( "unknown" ),
	paternalGrandSireBreed: z
			.string ()
			.min ( 1, {
				message: "Sire Father's Breed" + " is" + " Required",
			} )
			.default ( "unknown" ),
	maternalGrandDamDGR: z
			.string ()
			.min ( 1, {
				message: "Dam Mother's DGR is" + " Required",
			} )
			.default ( "unknown" ),
	maternalGrandDamName: z
			.string ()
			.min ( 1, {
				message: "Dam's Mother's Name is Required",
			} )
			.default ( "unknown" ),
	maternalGrandDamBreed: z
			.string ( { message: "Dam's Mother's Breed is Required" } )
			.default ( "unknown" ),
	maternalGrandSireDGR: z
			.string ( { message: "Dam's Father's DGR is Required" } )
			.default ( "unknown" ),
	maternalGrandSireName: z
			.string ( { message: "Dam's Father's Name is Required" } )
			.default ( "unknown" ),
	maternalGrandSireBreed: z
			.string ( {
				message: "Grand Father's Breed is" + " Required",
			} )
			.default ( "unknown" ),
	coatColor: z.string ().min ( 1, { message: "Coat Color is Required" } ),
	size: z.string ().min ( 1, { message: "select Size" } ),
	birthWeight: z.string ().min ( 1, { message: "Enter birth weight" } ),
	// damWeightAtWeaning: z.string().min(1, {message: "Dam's
	// Weight is Required"}).default('unknown'),
	animalStatus: z.string ().min ( 1, { message: "animalStatus is Required" } ),
	age: z.string ().min ( 1, {
		message: "Age Nucleus is" + " Required",
	} ),
	paternalType: z
			.string ()
			.min ( 1, { message: "Paternal Type is Required" } )
			.default ( "unknown" ),
	racialComposition: z.string ().min ( 1, { message: "Breed is Required" } ),
	breedCompositionRatio: z
			.string ()
			.min ( 1, { message: "Breed Composition Ratio" } ),
	birthCondition: z
			.string ()
			.min ( 1, { message: "birthCondition Name is Required" } ),
    farmerID: z.string().optional(),
    farmID: z.string().optional(),
} )

export const updateAnimalSchema = z.object ( {
	gn: z.string ().min ( 4, "GN is Required" ).max ( 6 ),
	sex: z
			.union ( [
				z.string ().length ( 0 ),
				z.string ().min ( 1, { message: "Select area type" } ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	breedingType: z
			.union ( [
				z.string ().length ( 0 ),
				z
						.string ()
						.min ( 1, { message: "Breeding Type is Required" } )
						.default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	name: z
			.union ( [ z.string ().length ( 0 ), z.string ( { message: "Name is Required" } ) ] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	weight: z.number ().min ( 1, "Weight is" +
			" Required" )
			.optional ()
			.transform ( ( e ) => ( e === null ? undefined : e ) ),
	vaccination: z
			.union ( [
				z.string ().length ( 0 ),
				z.string ().min ( 1, { message: "Select area type" } ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	damDGR: z
			.union ( [ z.string ().length ( 0 ), z.string ().default ( "unknown" ) ] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	damName: z
			.union ( [
				z.string ().length ( 0 ),
				z.string ( { message: "Mother's Name is Required" } ).default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	damBreed: z
			.union ( [
				z.string ().length ( 0 ),
				z
						.string ()
						.min ( 1, { message: "Mother's Breed is Required" } )
						.default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	sireDGR: z
			.union ( [ z.string ().length ( 0 ), z.string ().default ( "unknown" ) ] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	sireName: z
			.union ( [
				z.string ().length ( 0 ),
				z
						.string ()
						.min ( 1, { message: "Father's Name is Required" } )
						.default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	sireBreed: z
			.union ( [
				z.string ().length ( 0 ),
				z
						.string ()
						.min ( 1, { message: "Father's Breed is Required" } )
						.default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	paternalGrandDamDGR: z
			.union ( [
				z.string ().length ( 0 ),
				z
						.string ( { message: "Sire Mother's Name is Required" } )
						.default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	paternalGrandDamName: z
			.union ( [
				z.string ().length ( 0 ),
				z
						.string ()
						.min ( 1, { message: "Sire Mother's Name is Required" } )
						.default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	paternalGrandDamBreed: z
			.union ( [
				z.string ().length ( 0 ),
				z
						.string ()
						.min ( 1, { message: "Sire Mother's Breed is Required" } )
						.default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	paternalGrandSireDGR: z
			.union ( [
				z.string ().length ( 0 ),
				z
						.string ()
						.min ( 1, { message: "Sire Father's DGR is Required" } )
						.default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	paternalGrandSireName: z
			.union ( [
				z.string ().length ( 0 ),
				z
						.string ()
						.min ( 1, { message: "Sire Father's Name is Required" } )
						.default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	paternalGrandSireBreed: z
			.union ( [
				z.string ().length ( 0 ),
				z
						.string ()
						.min ( 1, { message: "Sire Father's Breed is Required" } )
						.default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	maternalGrandDamDGR: z
			.union ( [
				z.string ().length ( 0 ),
				z
						.string ()
						.min ( 1, { message: "Dam Mother's DGR is Required" } )
						.default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	maternalGrandDamName: z
			.union ( [
				z.string ().length ( 0 ),
				z
						.string ()
						.min ( 1, { message: "Dam Mother's Name is Required" } )
						.default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	maternalGrandDamBreed: z
			.union ( [
				z.string ().length ( 0 ),
				z
						.string ( { message: "Dam Mother's Breed is Required" } )
						.default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	maternalGrandSireDGR: z
			.union ( [
				z.string ().length ( 0 ),
				z.string ( { message: "Dam Father's DGR is Required" } ).default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	maternalGrandSireName: z
			.union ( [
				z.string ().length ( 0 ),
				z.string ( { message: "Dam Father's Name is Required" } ).default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	maternalGrandSireBreed: z
			.union ( [
				z.string ().length ( 0 ),
				z
						.string ( { message: "Dam Father's Breed is Required" } )
						.default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	coatColor: z
			.union ( [
				z.string ().length ( 0 ),
				z.string ().min ( 1, { message: "Coat Color is Required" } ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	size: z
			.union ( [
				z.string ().length ( 0 ),
				z.string ().min ( 1, { message: "Select Size" } ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	birthWeight: z
			.union ( [
				z.number ().min ( 1 ),
				z.number ().min ( 1, { message: "Enter birth weight" } ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === 0 ? undefined : e ) ),
	animalStatus: z
			.union ( [
				z.string ().length ( 0 ),
				z.string ().min ( 1, { message: "Animal Status is Required" } ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	age: z
			.union ( [
				z.string ().length ( 0 ),
				z.string ().min ( 1, { message: "Age Nucleus is Required" } ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	paternalType: z
			.union ( [
				z.string ().length ( 0 ),
				z
						.string ()
						.min ( 1, { message: "Paternal Type is Required" } )
						.default ( "unknown" ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	racialComposition: z
			.union ( [
				z.string ().length ( 1 ),
				z.string ().min ( 1, { message: "Breed is Required" } ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? undefined : e ) ),
	breedCompositionRatio: z.string ( { message: "Breed Composition Ratio" } ),
	birthCondition: z
			.union ( [
				z.string ().length ( 1 ),
				z.string ().min ( 1, { message: "Birth Condition is Required" } ),
			] )
			.optional ()
			.transform ( ( e ) => ( e === "" ? "0" : e ) ),
} )

export type TAnimalSchema = z.infer<typeof animalSchema>;
export type TUpdateAnimalSchema = z.infer<typeof updateAnimalSchema>;
